import './style/index.less';
import AreaCode from './AreaCode';

export default AreaCode;
